import * as R from 'ramda'

// ()=> dev, qa, uat
export const getEnvType = R.prop('REACT_APP_ENV')

export const isDevEnv = () =>
  R.compose(R.equals('dev'), R.prop('REACT_APP_ENV'))(process.env)
export const isQaEnv = () =>
  R.compose(R.equals('qa'), R.prop('REACT_APP_ENV'))(process.env)
